import React from "react";
import { Modal } from "@mui/material";
import { XIcon } from "@heroicons/react/solid";
import { Button } from "../../components/ui";
import InlineLoader from "../../components/loader/InlineLoader";

const statusStyles = {
  pending: "status-pending",
  approved: "status-approved",
  rejected: "status-rejected",
  partial_approval: "bg-yellow-100 text-yellow-800 px-2.5 py-1 rounded-full text-xs font-bold",
};

const statusLabels = {
  pending: "Pending",
  approved: "Approved",
  rejected: "Rejected",
  partial_approval: "Partial Approval",
};

const FundRequestDetailModal = ({ open, onClose, request, isLoading }) => {
  return (
    <Modal open={open} onClose={onClose}>
      <div className="w-full h-full md:h-auto md:w-[90%] lg:w-[70%] max-w-2xl bg-white rounded-none md:rounded-2xl shadow-2xl absolute left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2 overflow-hidden border-0 md:border md:border-gray-150 flex flex-col">
        <div className="flex items-center justify-between px-6 py-4 bg-gray-50 border-b border-gray-200 flex-shrink-0">
          <h3 className="text-lg font-bold text-gray-800">Fund Request Details</h3>
          <button onClick={onClose} className="p-1 rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-200 transition-colors">
            <XIcon className="w-5 h-5" />
          </button>
        </div>
        <div className="p-6 space-y-5 flex-grow overflow-y-auto md:max-h-[80vh]">
          {isLoading ? (
            <div className="flex justify-center py-10">
              <InlineLoader className="w-8 h-8 text-primary" />
            </div>
          ) : request ? (
            <>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-4">
                  <div>
                    <span className="text-xs text-gray-400 font-semibold block uppercase">Employee</span>
                    <span className="font-semibold text-gray-800">{request.employee_name || "-"}</span>
                  </div>
                  <div>
                    <span className="text-xs text-gray-400 font-semibold block uppercase">Employee Code</span>
                    <span className="font-semibold text-gray-800">{request.employee_code || "-"}</span>
                  </div>
                  <div>
                    <span className="text-xs text-gray-400 font-semibold block uppercase">From Date</span>
                    <span className="font-semibold text-gray-800">{request.from_date || "-"}</span>
                  </div>
                  <div>
                    <span className="text-xs text-gray-400 font-semibold block uppercase">To Date</span>
                    <span className="font-semibold text-gray-800">{request.to_date || "-"}</span>
                  </div>
                </div>
                <div className="space-y-4">
                  <div>
                    <span className="text-xs text-gray-400 font-semibold block uppercase">Requested Amount</span>
                    <span className="font-bold text-xl text-gray-900">₹{request.requested_amount || 0}</span>
                  </div>
                  {request.approved_amount > 0 && (
                    <div>
                      <span className="text-xs text-gray-400 font-semibold block uppercase">Approved Amount</span>
                      <span className="font-bold text-xl text-green-600">₹{request.approved_amount}</span>
                    </div>
                  )}
                  {request.rejected_amount > 0 && (
                    <div>
                      <span className="text-xs text-gray-400 font-semibold block uppercase">Rejected Amount</span>
                      <span className="font-bold text-xl text-red-600">₹{request.rejected_amount}</span>
                    </div>
                  )}
                  <div>
                    <span className="text-xs text-gray-400 font-semibold block uppercase">Status</span>
                    <span className={`mt-1 inline-block ${statusStyles[request.approval_status] || "status-pending"}`}>
                      {statusLabels[request.approval_status] || request.approval_status}
                    </span>
                  </div>
                </div>
              </div>
              {request.remarks && (
                <div className="border-t border-gray-100 pt-4">
                  <span className="text-xs text-gray-400 font-semibold block uppercase mb-1">Remarks</span>
                  <span className="text-sm text-gray-700 block bg-gray-50 p-3 rounded-xl border border-gray-150">
                    {request.remarks}
                  </span>
                </div>
              )}
              {request.reason && (
                <div className="p-3 bg-red-50 border border-red-100 rounded-xl text-red-700">
                  <span className="text-xs font-bold block uppercase mb-1">Reason</span>
                  <span className="text-sm">{request.reason}</span>
                </div>
              )}
            </>
          ) : (
            <div className="text-center py-4 text-gray-400">
              No fund request data found.
            </div>
          )}
          <div className="flex justify-end pt-4 border-t border-gray-100">
            <Button onClick={onClose}>Close</Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default FundRequestDetailModal;
